export const address = {
	addressForm: {
		selectFromSavedAddresses: 'Select From Saved Addresses',
		saveDropShipAddress: 'Save Drop Ship Address',
		company: 'Company Name',
		firstName: {
			label: 'First Name',
		},
		lastName: {
			label: 'Last Name',
		},
		state: 'State/Province',
		phoneNumber: {
			label: 'Phone Number',
			placeholder: 'Phone Number',
		},
	},
	addressCard: {
		deliveryAddress: 'Delivery Address',
		shipTo: 'Ship To'
	}
};